const assignmentStatus = (c) => {
    switch (c) {
        case "C":
            return "Cancelled";
        case "E":
            return "Ended";
        case "F":
            return "Filled";
        case "H":
            return "Held";
        case "O":
            return "Open";
        case "S":
            return "Staffed";
        default:
            return c;
    }
};
export { assignmentStatus };
